// import React from "react";
// import { Helmet, HelmetProvider } from "react-helmet-async";
// import Home from "./Pages/Home";


// function App() {
//   return (
//     <HelmetProvider>
//       <>
//         <Helmet>
//           <title>Edge Pixel | Creative Digital Agency</title>
//           <meta
//             name="description"
//             content="Edge Pixel is a creative digital agency delivering high-quality websites, branding, and marketing solutions."
//           />

//           {/* Open Graph (Facebook, LinkedIn) */}
//           <meta property="og:title" content="Edge Pixel | Creative Digital Agency" />
//           <meta
//             property="og:description"
//             content="Edge Pixel is a creative digital agency delivering high-quality websites, branding, and marketing solutions."
//           />
//           <meta property="og:type" content="website" />
//           <meta property="og:url" content="https://www.edgepixel.com" />
//           <meta property="og:image" content="/og-image.jpg" />

//           {/* Twitter Card */}
//           <meta name="twitter:card" content="summary_large_image" />
//           <meta name="twitter:title" content="Edge Pixel | Creative Digital Agency" />
//           <meta
//             name="twitter:description"
//             content="Edge Pixel is a creative digital agency delivering high-quality websites, branding, and marketing solutions."
//           />
//           <meta name="twitter:image" content="/twitter-image.jpg" />

//           {/* Google Site Verification */}
//           <meta
//             name="google-site-verification"
//             content="YOUR_VERIFICATION_CODE"
//           />

//           {/* Favicon */}
//           <link rel="icon" href="/favicon.ico" />

//           {/* Google Analytics */}
//           <script async src={`https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX`}></script>
//           <script>
//             {`
//               window.dataLayer = window.dataLayer || [];
//               function gtag(){dataLayer.push(arguments);}
//               gtag('js', new Date());
//               gtag('config', 'G-XXXXXXX');
//             `}
//           </script>
//         </Helmet>

//         <Home />
//       </>
//     </HelmetProvider>
//   );
// }

// export default App;

import React from "react";
import ComingSoonPage from "./Pages/ComingSoonPage";


function App() {
  return <ComingSoonPage />;
}

export default App;